const tasks = (axios) => {
  return {

    /**
         * @param params
         * @method get
         * @api /api/tasks/get_all?page={page}&ppage={perPage}
         */
    get (params) {
      return axios.get(`/tasks/get_all/?page=${params.page}&ppage=${params.perPage}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/tasks/get_tasks_job/{id}
         */
    getTaskJob (id) {
      return axios.get(`/tasks/get_tasks_job/${id}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/tasks/get/{id}
         */
    getTaskItem (id) {
      return axios.get(`/task/get/${id}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/job_att_download/{id}
         */
    downloadFile (id) {
      return axios.get(`/job_att_download/${id}`)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/upload_attachment/{id}
         */
    uploadFile (params) {
      return axios.post(`/task/upload_attachment/${params.id}`, params.file)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/task/update/{taskId}
         */
    updateTask (params) {
      return axios.post(`/task/update/${params.id}`, params.description)
        .then((response) => response);
    },

    /**
         * @param id
         * @method post
         * @api /api/task/getFiles/{taskId}
         */
    getFilePackage (id) {
      return axios.post(`/task/getFiles/${id}`)
        .then((response) => response);
    },
  };
};

export default tasks;
